"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdatePatSchema = exports.CreatePatSchema = exports.PersonalAccessTokenSchema = exports.PatStatusEnum = void 0;
const zod_1 = require("zod");
// ── Personal Access Token ──────────────────────────────────────────
exports.PatStatusEnum = zod_1.z.enum(["active", "revoked"]);
exports.PersonalAccessTokenSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    name: zod_1.z.string().min(1).max(100),
    userId: zod_1.z.string(),
    scopes: zod_1.z.array(zod_1.z.string()),
    tokenPrefix: zod_1.z.string(), // first 12 chars for display (e.g. "pat_a1b2c3d4")
    expiresAt: zod_1.z.string().nullable(),
    status: exports.PatStatusEnum.default("active"),
    lastUsedAt: zod_1.z.string().nullable(),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
});
exports.CreatePatSchema = zod_1.z.object({
    name: zod_1.z.string().min(1).max(100),
    scopes: zod_1.z.array(zod_1.z.string()).min(1),
    expiresAt: zod_1.z.string().nullable().optional(),
});
exports.UpdatePatSchema = zod_1.z.object({
    name: zod_1.z.string().min(1).max(100),
});
